import type { ApiErrorResponse } from '@/services/brands/types'
import type { AxiosError } from 'axios'

export function extractErrorMessage(error: AxiosError<ApiErrorResponse>): string {
  const defaultMessage = 'Something went wrong'
  const status = error.response?.status
  const message = error.response?.data?.message

  if (status === 422) {
    const data = error.response?.data?.data
    if (data && typeof data === 'object') {
      const firstError = Object.values(data)[0]
      return typeof firstError === 'string' ? firstError : 'Invalid data'
    }
  }

  return message || defaultMessage
}
